function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84 4.80664V49.7175C84 51.3809 82.7525 52.6284 81.0891 52.6284H2.91089C1.24752 52.6284 0 51.3809 0 49.7175V4.80664L37.8416 33.0839C39.9208 34.7472 44.0792 34.7472 46.5743 33.0839C53.6436 27.6779 84 4.80664 84 4.80664Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.45545 0C-0.623762 0 -0.207921 2.07921 1.0396 2.49505C13.5149 12.0594 25.5743 21.2079 38.0495 30.3564C40.1287 32.0198 43.8713 32.0198 45.5346 30.3564C58.0099 21.2079 70.4851 12.0594 82.5445 2.49505C83.7921 2.07921 84.2079 0 82.5445 0H1.45545Z",
  fill: "white"
});

function SvgWelcomeMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 53,
    viewBox: "0 0 84 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeMail);
export default __webpack_public_path__ + "static/media/welcomeMail.73312ed6.svg";
export { ForwardRef as ReactComponent };